module.exports = __webpack_public_path__ + "img/ANTENNA TWIRL BW.9de452f.svg";